import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija para móvil. Aparece SOLO después de que el visitante
 * llegó a la sección de oferta (la primera revelación del precio) y se oculta
 * en el footer: antes de ese punto la carta no muestra precio ni compra.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const offer = document.getElementById('oferta');
      const footer = document.getElementById('site-footer');
      const offerPassed = offer ? offer.getBoundingClientRect().top < window.innerHeight * 0.4 : false;
      const footerReached = footer ? footer.getBoundingClientRect().top <= window.innerHeight : false;
      setVisible(offerPassed && !footerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-warm bg-ivory/97 backdrop-blur transition-transform duration-200 ease-out md:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-227" data-mp="2s5hb35x811w4">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-228" data-mp="363p10tvub2xs">
        <div className="min-w-0" data-id="element-229" data-mp="17q5o9x6vz54d">
          <p className="truncate font-sans text-[0.6rem] font-bold uppercase tracking-[0.14em] text-charcoal/55" data-id="element-230" data-mp="17r6yjzg2vnl1">
            8 kits + 5 bonos
          </p>
          <p className="font-display text-xl leading-tight tabular-nums text-charcoal" data-id="element-231" data-mp="2f13bnacbt640">
            {PRICE.current}
          </p>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="flex min-h-[46px] max-w-[11.5rem] shrink-0 items-center justify-center rounded-full bg-gold px-5 py-2 text-center font-sans text-[0.62rem] font-bold uppercase leading-[1.15] tracking-[0.08em] text-charcoal transition-colors duration-200 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50" data-id="element-232" data-mp="2a4mmqdxaynpv">
          Quiero el sistema
        </a>
      </div>
    </div>;
}